import { ReactNode } from "react";
import { useShallow } from "zustand/react/shallow";

import TableCellGroup from "ds/components/Table/Row/CellGroup";
import useIntentModuleResources from "shared/IntentProject/useIntentModuleResources";

import useIntentProjectResourcesHierarchyStore from "../useResourcesHierarchyStore";
import { INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE } from "../constants";

type IntentProjectResourcesTableModuleGroupToggleProps = {
  groupId: string;
  intentProjectId: string;
  children: ReactNode;
};

const IntentProjectResourcesTableModuleGroupToggle = ({
  groupId,
  intentProjectId,
  children,
}: IntentProjectResourcesTableModuleGroupToggleProps) => {
  const { fetchModuleResources, loading } = useIntentModuleResources(intentProjectId);

  const { isOpen, hasLoadedChildren, toggleGroup, loadGroupChildren } =
    useIntentProjectResourcesHierarchyStore(
      useShallow((state) => ({
        isOpen: state.groupMeta[groupId]?.isOpen ?? false,
        hasLoadedChildren: !!state.childrenByGroup[groupId],
        toggleGroup: state.toggleGroup,
        loadGroupChildren: state.loadGroupChildren,
      }))
    );

  const onPress = () => {
    toggleGroup(groupId);

    if (!isOpen && !hasLoadedChildren) {
      loadGroupChildren(groupId, ({ after }) =>
        fetchModuleResources(groupId, INTENT_PROJECT_MODULE_RESOURCES_PER_PAGE, after)
      );
    }
  };

  return (
    <TableCellGroup
      title="Toggle module resources"
      isActive
      isGroupOpen={isOpen}
      loading={loading}
      onPress={onPress}
    >
      {children}
    </TableCellGroup>
  );
};

export default IntentProjectResourcesTableModuleGroupToggle;
